'use client';

import {createContext, useContext, useEffect, useRef, useState} from 'react';
import {frontendApiClient} from "@/services/api";

const AuthContext = createContext<{ isAuthenticated: boolean }>({isAuthenticated: false});

export const AuthProvider = ({children}: { children: React.ReactNode }) => {
    const [isAuthenticated, setAuthenticated] = useState(false);
    const refreshIntervalRef = useRef<NodeJS.Timeout | null>(null);

    const REFRESH_INTERVAL_MINUTES = 1; // если access токен живёт 5 минут

    const refreshToken = async () => {
        try {
            await frontendApiClient.post('/account/refresh');
            setAuthenticated(true);
        } catch {
            setAuthenticated(false);
            stopRefreshing(); // остановим повторы, если не авторизован
        }
    };

    const startRefreshing = () => {
        // запускаем периодический refresh
        refreshIntervalRef.current = setInterval(() => {
            refreshToken();
        // }, REFRESH_INTERVAL_MINUTES * 60 * 1000);
        }, 10 * 1000);
    };

    const stopRefreshing = () => {
        if (refreshIntervalRef.current) {
            clearInterval(refreshIntervalRef.current);
            refreshIntervalRef.current = null;
        }
    };

    useEffect(() => {
        refreshToken().then(() => {
            startRefreshing(); // запускаем цикл только если успешно
        });

        return () => {
            stopRefreshing(); // очищаем при размонтировании
        };
    }, []);

    return <AuthContext.Provider value={{isAuthenticated}}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);